<template>
  <v-app class="bckgrnd">
    <!-- <v-breadcrumbs large :items="breadcrumbs">
      <template v-slot:divider>
        <v-icon color="#64f5a9" size="25">keyboard_arrow_right</v-icon>
      </template>
    </v-breadcrumbs> -->

    <v-card class="form-container" style="border:1px solid">
      <h2 style="text-align:center;font-weight:bold"><span style="font-size:50px">M</span>Y&nbsp;<span style="font-size:50px">C</span>USTOMER</h2>
      
      <v-card-title>
        <v-text-field
          flat
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="usersTableHeader" :items="users" :search="search">
        <template v-slot:items="props">
          <tr style="background-color:#ffcdd2" v-if="props.item.status=='Unapprove'">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left hvr" @click="onEdit(props.item)">
            <v-tooltip top color="#E31E24">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.item.fullName }}</span>
              </template>
              <span>View Details</span>
            </v-tooltip>
          </td>
          <td class="text-xs-left">{{ props.item.country }}</td>
          <td class="text-xs-left">{{ props.item.companyName }}</td>
          <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          </tr>

          <tr style="background-color:#bbdefb" v-if="props.item.status=='Approve'">
            <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left hvr" @click="onEdit(props.item)">
            <v-tooltip top color="#E31E24">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ props.item.fullName }}</span>
              </template>
              <span>View Details</span>
            </v-tooltip>
          </td>
          <td class="text-xs-left">{{ props.item.country }}</td>
          <td class="text-xs-left">{{ props.item.companyName }}</td>
          <td class="text-xs-left">{{ props.item.mobileNumber }}</td>
          <td class="text-xs-left">{{ props.item.email }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          </tr>
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      /* breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Users",
          disabled: true,
          to: "/user"
        }
      ], */
      userCount: 0,
      
      users: [],
      search: "",
      usersTableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Full Name", value: "fullName" },
        { text: "Country", value: "country" },
        { text: "Company Name", value: "companyName" },
        { text: "Mobile Number", value: "mobileNumber" },
        { text: "Email ID", value: "email" },
        { text: "Status", value: "status" }
      ]
    };
  },

  methods: {
    getData() {
      this.axios
        .get(config.API + "Admin", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.users = res.data;
          this.$Progress.finish();
          this.getData();
        })
        .catch(err => {
          this.$Progress.fail();
        });
    },
   // :rows-per-page-items="[10,15,20]"
    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete this user !!")) {
        this.axios
          .delete(config.API + `Admin/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("User deleted successfully");
            //this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    onEdit(item) {
      this.$router.push(`editUser/${item.id}`);
    },

    onPassword(item) {
      this.$router.push(`changePassword/${item.id}`);
    }
  },

  mounted() {
    this.getData();
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.bckgrnd {
  background-image: linear-gradient(-180deg, #eeeeee, #bdbdbd) !important;
  background-size:cover !important;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.txt_dec:hover {
    text-decoration: none !important;
}
.hvr:hover {
  cursor: pointer;
  color: #3486D7;
  text-decoration: underline;
}
</style>